import { gql } from '@apollo/client';

const SlackMemberFieldsFragment = gql`
  fragment SlackMemberFields on SlackMember {
    id
    name
  }
`;

const SlackTeamFieldsFragment = gql`
  fragment SlackTeamFields on SlackTeam {
    id
    name
  }
`;

const SlackChannelFieldsFragment = gql`
  fragment SlackChannelFields on SlackChannel {
    id
    name
    type
  }
`;

export const SlackDestinationEntitiesFieldsFragment = gql`
  fragment SlackDestinationEntitiesFields on SlackDestinationEntities {
    team {
      ...SlackTeamFields
    }
    channels {
      ...SlackChannelFields
    }
    members {
      ...SlackMemberFields
    }
  }
  ${SlackTeamFieldsFragment}
  ${SlackChannelFieldsFragment}
  ${SlackMemberFieldsFragment}
`;

export const SlackInstallationFieldsFragment = gql`
  fragment SlackInstallationFields on SlackInstallation {
    member {
      ...SlackMemberFields
    }
    team {
      ...SlackTeamFields
    }
  }
  ${SlackMemberFieldsFragment}
  ${SlackTeamFieldsFragment}
`;

const SlackEntitySourceFieldsFragment = gql`
  fragment SlackEntitySourceFields on SlackEntitySource {
    entityType
    entityId
  }
`;

const SlackAdminSourceFieldsFragment = gql`
  fragment SlackAdminSourceFields on SlackAdminSource {
    __typename
  }
`;

const SlackSourceFieldsFragment = gql`
  fragment SlackSourceFields on SlackSource {
    ... on SlackEntitySource {
      ...SlackEntitySourceFields
    }
    ... on SlackAdminSource {
      ...SlackAdminSourceFields
    }
  }
  ${SlackEntitySourceFieldsFragment}
  ${SlackAdminSourceFieldsFragment}
`;

const SlackChannelDestinationFieldsFragment = gql`
  fragment SlackChannelDestinationFields on SlackChannelDestination {
    team {
      ...SlackTeamFields
    }
    channel {
      ...SlackChannelFields
    }
  }
  ${SlackTeamFieldsFragment}
  ${SlackChannelFieldsFragment}
`;

const SlackMemberDestinationFieldsFragment = gql`
  fragment SlackMemberDestinationFields on SlackMemberDestination {
    team {
      ...SlackTeamFields
    }
    member {
      ...SlackMemberFields
    }
  }
  ${SlackTeamFieldsFragment}
  ${SlackMemberFieldsFragment}
`;

export const SlackDestinationFieldsFragment = gql`
  fragment SlackDestinationFields on SlackDestination {
    ... on SlackChannelDestination {
      ...SlackChannelDestinationFields
    }
    ... on SlackMemberDestination {
      ...SlackMemberDestinationFields
    }
  }
  ${SlackChannelDestinationFieldsFragment}
  ${SlackMemberDestinationFieldsFragment}
`;

export const SlackConnectionFieldsFragment = gql`
  fragment SlackConnectionFields on SlackConnection {
    source {
      ...SlackSourceFields
    }
    destination {
      ...SlackDestinationFields
    }
  }
  ${SlackSourceFieldsFragment}
  ${SlackDestinationFieldsFragment}
`;
